class CventAnalyticsWorkerClient {
    constructor({ onError, ...config }) {
        this.onError = onError;
        this.worker = new Worker(new URL('./worker.js', import.meta.url));
        this.worker.onmessage = this.onMessage;
        this.worker.postMessage({
            type: 'init',
            config
        });
    }
    onMessage(ev) {
        if (ev.data.type === 'error' && this.onError) {
            this.onError(ev.data.err);
        }
    }
    send(data) {
        this.worker.postMessage({ type: 'track', payload: data });
    }
}
export default CventAnalyticsWorkerClient;
//# sourceMappingURL=CventAnalyticsWorkerClient.js.map